const FilterListItem = ({
  isSelected = false,
  title,
  Icon,
  onClick,
  count = 0,
}: {
  isSelected?: boolean;
  title: string;
  Icon: JSX.Element;
  onClick: () => void;
  count?: number;
}) => {
  return (
    <div
      className={`dr-p-12 BodyRegular dr-flex dr-flex-row dr-justify-between ${isSelected ? "dr-text-darwin-touch-primary-primary dr-bg-darwin-touch-primary-bg-light" : "dr-text-doctor-darwin-neutral-800"}`}
      onClick={onClick}
    >
      <div className="dr-flex dr-flex-row dr-items-center dr-gap-x-6 dr-w-full">
        {Icon}
        <div className="dr-flex dr-flex-row dr-justify-between dr-w-full">
          <p
            className={
              isSelected
                ? "dr-text-darwin-touch-primary-primary BodyBold"
                : "dr-text-doctor-darwin-neutral-1000"
            }
          >
            {title}
          </p>
        </div>
        {count > 0 ? (
          <div
            className={`Caption2Bold dr-flex dr-items-center dr-justify-center dr-w-23 dr-h-20 dr-rounded-full dr-text-darwin-touch-primary-primary ${isSelected ? "dr-bg-darwin-touch-neutral-0" : "dr-bg-darwin-touch-primary-bg-light"}`}
          >
            {count}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FilterListItem;
